import CodeSnippet from 'components/CodeSnippet';
import * as CODE from "../../../../src/constants/voice-calling";
import Notification from 'components/Notification';
import * as React from 'react';
export default {
  CodeSnippet,
  CODE,
  Notification,
  React
};